$( document ).ready( function() {
    
    $( '.loadPixcells' ).on( 'click', function () 
    {
        //var url = "https://lab.pikcells.com/ba-configurator";
        var url =  "https://configurator.blossomavenue.co.uk"; //"https://lab.pikcells.com/ba/blossom-avenue-configurator/0.2.3/";
        $('#pixcellsIframe').attr('src', url);
    });
});